export default __webpack_public_path__ + "static/media/ic_calendar_blue.ce1dbb62.svg";